import {
    server
} from "@/api";


export const create = async (product) => {
    return await server().post('api/products', product)
}

export const all = async (params) => {
    return await server().get('api/products/all', { params });
}

export const edit = async (id, params = {}) => {
    return await server().get('api/products/' + id + '/edit', { params });
}

export const get = async (id, params = {}) => {
    return await server().get('api/products/' + id, { params });
}

export const agents = async (id, params = {}) => {
    return await server().get('api/products/' + id + '/agents', { params });
}

export const marketers = async (id, params = {}) => {
    return await server().get('api/products/' + id + '/marketers', { params });
}

export const status = async (id, params = {}) => {
    return await server().get('api/products/' + id + '/status', { params });
}

export const inventory = async (id, params = {}) => {
    return await server().get('api/products/' + id + '/inventory', { params });
}

export const paginate = async (params) => {
    return await server().get('api/products', { params });
}

export const update = async (id, product) => {
    return await server().post(`api/products/${id}`, product);
}

export const cross = async (ids, params = {}) => {
    return await server().get('api/products/cross', { params: { ids, ...params } });
}

export const offers = async (ids, params = {}) => {
    return await server().get('api/products/offers', { params: { ids, ...params } });
}

export default {
    create,
    get,
    all,
    update,
    paginate,
    agents,
    edit,
    cross,
    offers
}